import React from 'react'
import { useCollapsedState } from '../hooks/useCollapsedState'
import { useAssistantTasks } from '../hooks/useAssistantTasks'
import { AssistantPanel } from './AssistantPanel'
import { AssistantLauncher } from './AssistantLauncher'

export const AssistantContainer: React.FC = () => {
  const { collapsed, setCollapsed } = useCollapsedState()
  const { summary } = useAssistantTasks()

  if (collapsed) {
    return (
      <AssistantLauncher
        urgentCount={summary.urgent}
        onOpen={() => setCollapsed(false)}
      />
    )
  }

  return (
    <div
      data-cy="assistant--wrapper"
      style={{
        position: 'fixed',
        top: 8,
        right: 8,
        zIndex: 120,
      }}
    >
      <AssistantPanel onClose={() => setCollapsed(true)} />
    </div>
  )
}
